export function randomString() {
  return Math.random().toString(36).split(".")[1];
}
